import React from "react";
import { auth } from "../firebase";
import { useLang } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";
import Logo from './Logo';


/* Bootstarp */
import { Button } from 'react-bootstrap'; // Importa el modal de react-bootstrap

export default function NavbarIndex( {static_page = false, login_button = true} ) {

  /* Inciar constante de traducción */
  const { t } = useLang();
  /* Variables del Usuario */
  const { user } = useAuth();
  const logout = () => {
    auth.signOut();
  };


  return (
    <div className="NavbarHome">
      <nav className={`navbar navbar-index ${static_page ? "nav_static_page" : ""}`}>
        <div className="container-fluid">
          <div className="navbar-brand">
            <Logo LOGO_TEXT={t("LOGO_TEXT")} />
          </div>
          {login_button ? (
            <div className="my-2 my-lg-0" id="navbarCollapse">
              <ul className="navbar-nav me-auto mb-2 mb-md-0">
                {user ? (
                  <li className="nav-item logged-in">
                    <Button
                      variant="danger"
                      onClick={logout}
                    >
                      {t("INDEX_LOGOUT_BUTTON")}
                    </Button>
                  </li>
                ) : (
                  <li className="nav-item logged-out">
                    <Button
                      variant="danger"
                      href="/login"
                    >
                      {t("INDEX_LOGIN_BUTTON")}
                    </Button>
                  </li>
                )}
              </ul>
            </div>
          ) : null}
        </div>
      </nav>



















      {/*



      <Modal show={showSigninModal} onHide={handleCloseSigninModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t("INDEX_REGISTER_TITLE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
        </Modal.Body>
      </Modal>
      */}

    {/*}
      <!-- Signup modal -->
    <div class="modal" tabindex="-1" id="signupModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title"><?php echo INDEX_REGISTER_TITLE; ?></h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body p-5 pt-3">
                    <form id="singupForm">
                        <div class="form-floating mb-3">
                            <input type="email" class="form-control rounded-3" id="signup-email" autocomplete="username" placeholder="name@example.com">
                            <label for="floatingInput"><?php echo INDEX_SINGUP_EMAIL; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="password" class="form-control rounded-3" id="signup-password" autocomplete="current-password" placeholder="<?php echo INDEX_SINGUP_PASSWORD; ?>">
                            <label for="floatingPassword"><?php echo INDEX_SINGUP_PASSWORD; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control rounded-3" id="signup-first-name" placeholder="<?php echo INDEX_SINGUP_FIRSTNAME; ?>">
                            <label for="floatingInput"><?php echo INDEX_SINGUP_FIRSTNAME; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control rounded-3" id="signup-last-name" placeholder="<?php echo INDEX_SINGUP_LASTNAME; ?>">
                            <label for="floatingInput"><?php echo INDEX_SINGUP_LASTNAME; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control rounded-3" id="signup-phone" placeholder="<?php echo INDEX_SINGUP_PHONE; ?>">
                            <label for="floatingInput"><?php echo INDEX_SINGUP_PHONE; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control rounded-3" id="signup-address" placeholder="<?php echo INDEX_SINGUP_ADRESS; ?>">
                            <label for="floatingInput"><?php echo INDEX_SINGUP_ADRESS; ?></label>
                        </div>
                        <button class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit"><?php echo INDEX_SINGUP_BUTTON; ?></button>
                        <small class="text-body-secondary"><?php echo INDEX_SINGUP_TERMS; ?></small>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <script src="<?php echo URL_JS_LOGIN; ?>/signupForm.js" type="module"></script>

    <!-- Signin modal -->
    <div class="modal" tabindex="-1" id="signinEmailModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-4 shadow">
                <div class="modal-header p-5 pb-4 border-bottom-0">
                    <h1 class="fw-bold mb-0 fs-2"><?php echo INDEX_SINGIN_TITLE; ?></h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body p-5 pt-0">
                    <form id="signin-form" class="">
                        <div class="form-floating mb-3">
                            <input type="email" class="form-control rounded-3" id="signin-email" autocomplete="username" placeholder="name@example.com">
                            <label for="floatingInput"><?php echo INDEX_SINGIN_EMAIL; ?></label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="password" class="form-control rounded-3" id="signin-password" autocomplete="current-password" placeholder="Password">
                            <label for="floatingPassword"><?php echo INDEX_SINGIN_PASSWORD; ?></label>
                        </div>
                        <button class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit"><?php echo INDEX_SINGIN_BUTTON; ?></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    */}



    </div>


  );
}
